
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/electric-commercial-vehicles/Bajaj/re-e-tec",
      function () {
        return require("private-next-pages/electric-commercial-vehicles/Bajaj/re-e-tec/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/electric-commercial-vehicles/Bajaj/re-e-tec"])
      });
    }
  